import React from 'react';
import PreviewRouteLoader from './PreviewRouteLoader';
import PreviewLayout from '../../components/preview/PreviewLayout';

const ListingPreviewPage: React.FC = () => {
  return (
    <PreviewRouteLoader>
      <PreviewLayout />
    </PreviewRouteLoader>
  );
};

export default ListingPreviewPage;
